import { Component, OnDestroy, OnInit } from '@angular/core'
import {
    AuthService,
    ClientTopServices,
    MatrixServices,
    ModalService,
    RestServices,
    SharedServices,
    StateServices,
} from '../../../services'

import { ActivatedRoute, Router } from '@angular/router'
import { DomSanitizer } from '@angular/platform-browser'
import { imageUrl } from '../../../../helper'
import { onsNotification } from 'ngx-onsenui'
import { isUndefined } from 'util'
import { CookieService } from 'ngx-cookie-service'

@Component({
    selector: 'app-layout-app-client-detail',
    templateUrl: './layout-app-client-detail.component.html',
    styleUrls: [
        '../../../stagingcss/root-ui-view.component.css',
        '../../../stagingcss/main-body.component.css',
        '../../../stagingcss/main-view.component.css',
        '../../../stagingcss/lui-select.component.css',
        './layout-app-client-detail.component.css',
    ],
})
export class LayoutAppClientDetailComponent implements OnInit, OnDestroy {

    en = {}
    showEN = true
    arrayMenu = []
    arrayMenuClient = [
        { id: 1, routerLink: 'home', name: 'app-client-detail-top' },
        { id: 2, routerLink: 'profile', name: 'app-client-detail-profile' },
        { id: 3, routerLink: 'aligner', name: 'app-client-detail-aligner' },
        { id: 4, routerLink: 'compliance', name: 'app-client-detail-compliance' },
        { id: 5, routerLink: 'device', name: 'app-client-detail-device' },
        { id: 6, routerLink: 'timeline', name: 'app-client-detail-timeline' },
        { id: 6, routerLink: 'communication', name: 'app-client-detail-communication' },
        { id: 9, routerLink: 'receipt', name: 'app-client-detail-receipt' },
        { id: 7, routerLink: 'mail', name: 'app-client-detail-mail' },
        { id: 8, routerLink: 'audit', name: 'app-client-detail-audit' },
    ]
    arrayMenuClientPresentation = [
        { id: 1, routerLink: 'home', name: 'app-client-detail-top' },
        { id: 3, routerLink: 'aligner', name: 'app-client-detail-aligner' },
        { id: 4, routerLink: 'compliance', name: 'app-client-detail-compliance' },
        { id: 5, routerLink: 'device', name: 'app-client-detail-device' },
        { id: 6, routerLink: 'timeline', name: 'app-client-detail-timeline' },
    ]
    statusSaveMail
    url
    idClient
    resourceUrl = 'resource'
    clientInfo: any
    listSearch: any
    displayDevice = false
    expand_mode = ''
    app_full_scree_submenubox = ''
    test_url
    trustedUrl
    urlImage: object = {}
    urlImageAge: object = {}
    baseImageUrl = imageUrl
    operator
    redirectUrl: any = ''
    activeIndex: any
    tmpActiveIndex: any
    isPresentation: Boolean = false
    presentationName: any
    statusNewClient: Boolean = false

    getStatusClient
    getDiscard
    unscrProfileSave
    statusMobile = false
    faceImage

    constructor(private auth: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private modalservice: ModalService, private route: ActivatedRoute, private sanitizer: DomSanitizer, public matrixServices: MatrixServices, private clientTopServices: ClientTopServices, private stateServices: StateServices, private cookieService: CookieService) {
        this.arrayMenu = this.arrayMenuClient
        this.statusMobile = this.auth.getUser().appMobile

        this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success) {
                    this.modalservice.emitChange(success)
                }
                // Todo: switch case or if/elseif
                if (success === 'activeAlertSaveMail') {
                    this.statusSaveMail = true
                }
                if (success === 'hiddenModalSaveMail') {
                    this.statusSaveMail = null
                }
                // if (localStorage.presentationModeValue == 'true') {
                //   this.arrayMenu = this.arrayMenuClientPresentation;
                // }
                if (success == 'fullPosisinScreenHidden') {
                    this.hiddenexpand_mode(true)
                }
                if (success == 'fullPosisinScreenActive') {
                    this.hiddenexpand_mode(false)
                }
                // else {
                //   this.arrayMenu = this.arrayMenuClient;
                // }
                // if (success && success[0] && success[0] === 'removeListOfImage') {
                    // let arrRegistration = success[1]
                    // let faceImage = this.urlImage['id']
                    // if (typeof arrRegistration !== 'undefined' && arrRegistration.length > 0) {
                    //     arrRegistration.sort((function(obj1, obj2) {
                    //         return obj1.dateStringToInit - obj2.dateStringToInit
                    //     }))
                    //     const imageFrontSmile = this.getFrontSmileToAvatar(arrRegistration)
                    //     if (imageFrontSmile !== undefined) {
                    //         if (typeof faceImage === 'undefined') {
                    //             this.callApiUpdateFaceImage(imageFrontSmile)
                    //         } else if (faceImage !== '') {
                    //             if (faceImage['id'] !== imageFrontSmile['id']) {
                    //                 this.callApiUpdateFaceImage(imageFrontSmile)
                    //             } else if (imageFrontSmile['matrix'] != undefined && faceImage['matrix'] !== imageFrontSmile['matrix'].toString()) {
                    //                 this.callApiUpdateFaceImage(imageFrontSmile)
                    //             }
                    //         }
                    //     }
                    // } else {
                    //     this.callApiEmptyFaceImage()
                    // }
                // }
                if(success){
                    if(success[0] == 'Receipt') this.activeIndex = 0

                }

            })

        this.en = this.auth.showLang(this.showEN)
        this.router.events.subscribe(url => {
            if (url['snapshot']) {
                if (url['snapshot']._routerState.url && url['snapshot']._routerState.url.indexOf('device') !== -1) {
                    this.displayDevice = true
                    const activeDevicePage = ['activeDevicePage', true]
                    this._sharedService.emitChange(activeDevicePage)
                } else {
                    this.displayDevice = false
                    const activeDevicePage = ['activeDevicePage', false]
                    this._sharedService.emitChange(activeDevicePage)
                }
            }
        })
        let clientId = 'id-not-found'
        if (route.url['value'][4]) {
            clientId = route.url['value'][4].path
            this.idClient = clientId
        }
 
        this.test_url = './client/main/' + clientId + '/preview'
        this.redirectUrl = './app/main/client/edit/' + clientId + '/'
        this.trustedUrl = sanitizer.bypassSecurityTrustResourceUrl(this.test_url)

        this.expand_mode = ''
        this.app_full_scree_submenubox = 'active'
    }

    ngOnInit() {
        this.statusNewClient = false
        this.activeIndex = 0
        if (localStorage.presentationModeValue == 'true') {
            this.arrayMenu = this.arrayMenuClientPresentation
        } else {
            this.arrayMenu = this.arrayMenuClient
        }
        if (this.idClient) {
            this.callApiInfoClient(this.idClient)
        }
        // this.getStatusDiscard();
        this.getStatusNewClient()
        this.getImageFace()
        this.getNameChange()
        this.getActiveRefresh()
        this.getPresentationMode()
        this.getActiveIndex()
        this.getPreventationName()
        this.getProfileSave()
        this.initActiveIndex()
        this.getImageFacImage()

        this._sharedService.changeEmittedPresentationModeSearchData$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'arraySearchPresentationMode-selectData') {
                        if (success[1] === true) {
                            this.urlImage = {}
                            this.urlImage['id'] = ''
                        } else {
                            this.urlImage = this.urlImageAge
                        }
                    }
                }
            },
        )
    }

    ngOnDestroy() {
        if(this.getStatusClient)
            this.getStatusClient.unsubscribe()
        if(this.unscrProfileSave)
            this.unscrProfileSave.unsubscribe()
    }

    initActiveIndex() {
        const urlPage = this.router.url
        if (this.isPresentation) {
            this.arrayMenuClientPresentation.forEach((el, i) => {
                if (urlPage.includes(el['routerLink'])) {
                    this.activeIndex = i
                }
            })
        } else {
            this.arrayMenuClient.forEach((el, i) => {
                if (urlPage.includes(el['routerLink'])) {
                    this.activeIndex = i
                }
            })
        }
    }

    getProfileSave() {
        this.unscrProfileSave = this.stateServices.changeEmittedProfileSave$.subscribe(res => {
            if (res) {
                this.initActiveIndex()
                this.statusNewClient = false
                this.stateServices.emitChangeProfileSave(null)
            }
        })
    }

    getStatusNewClient() {
        this.getStatusClient = this._sharedService.changeEmitted$.subscribe(success => {
            if (success) {
                if (success && success[0] === 'activeAlertNewClient') {
                    this.statusNewClient = true
                } else if (success && success == 'statusDiscard') {
                    this.statusNewClient = false
                    this.activeIndex = this.tmpActiveIndex
                } else if (success && success == 'statusCancel') {
                    this.statusNewClient = true
                }
                this._sharedService.emitChange(null)
            }
        })
    }

//   getStatusDiscard() {
//     this.getDiscard = this._sharedService.changeEmitted$.subscribe(success => {
//         if (success && success == 'statusDiscard') {
//             this.activeIndex = jQuery.extend(true, 0, this.tmpActiveIndex);
//         }
//         this._sharedService.emitChange(null);
//     });
//   }

    getPreventationName() {
        this.clientTopServices.changeEmiitedPreventationName$.subscribe(name => {
            if (name != null && name !== undefined && name['name'] !== undefined) {
                this.presentationName = name['name']
            }
        })
    }

    getActiveIndex() {
        this.clientTopServices.changeEmiitedActiveIndex$.subscribe(success => {
            if (success != null && success !== undefined && success['active'] === true) {
                this.activeIndex = this.tmpActiveIndex
            }
        })
    }

    getPresentationMode() {
        this._sharedService.changeEmittedPresentationModeSearchData$.subscribe(presentation => {
            if (presentation != null) {
                const arrTmp: any[] = presentation
                if (arrTmp.length > 0 && arrTmp[1] !== undefined) {
                    if (arrTmp[0] === 'arraySearchPresentationMode-selectData' && arrTmp[1] === true) {
                        this.arrayMenu = this.arrayMenuClientPresentation
                        this.isPresentation = arrTmp[1]
                    } else if (arrTmp[0] === 'arraySearchPresentationMode-selectData' && arrTmp[1] === false) {
                        this.arrayMenu = this.arrayMenuClient
                        this.isPresentation = arrTmp[1]
                    }
                }
            } else {
                const local: any = localStorage.getItem('presentationModeValue')
                if (local === 'true') {
                    this.arrayMenu = this.arrayMenuClientPresentation
                    this.isPresentation = true
                } else if (local === 'false') {
                    this.arrayMenu = this.arrayMenuClient
                    this.isPresentation = false
                } else {
                    this.arrayMenu = this.arrayMenuClient
                    this.isPresentation = false
                }
            }
            this.initActiveIndex()
        })
    }


    getActiveRefresh() {
        const tmpUrl: string = this.router.url
        const arrUrl: any[] = tmpUrl.split('/')
        const len: any = arrUrl.length
        const tab: any = arrUrl[len - 1]
        switch (tab) {
            case 'home':
                this.activeIndex = 0
                break
            case 'profile':
                this.activeIndex = 1
                break
            case 'aligner':
                this.activeIndex = 2
                break
            case 'compliance':
                this.activeIndex = 3
                break
            case 'device':
                this.activeIndex = 4
                break
            case 'timeline':
                this.activeIndex = 5
                break
            case 'mail':
                this.activeIndex = 6
                break
            case 'audit':
                this.activeIndex = 7
                break
            default:
                this.activeIndex = 0
                break
        }
    }

    getNameChange() {
        this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'nameChange-ProfileComponent') {
                        if (success[1]) {
                            this.operator = success[1]
                        }
                    }
                }
            })
    }

    getImageFace() {
        this._sharedService.changeEmitChangeImageFace$.subscribe(
            success => {
                if (success) {
                    console.log('getImageFace: ', success)
                    if (success[0] === 'ModalClientDetailRegistrationComponent-imageFaceClient') {
                        if (success[1]) {
                            this.urlImage = success[1]
                        }else {
                            this.urlImage = {}
                            this.urlImage['id'] = ''
                        }
                    }
                }
            })
    }

    hiddenexpand_mode(event: boolean) {
        if (event == true) {
            this.expand_mode = 'expand-mode'
            this.app_full_scree_submenubox = 'hidden'
        } else {
            this.expand_mode = ''
            this.app_full_scree_submenubox = 'active'
        }
    }


    returnListSearch(routesLink, activeIndex) {
        this.checkMovedUpPage(routesLink, activeIndex)
        this.listSearch = this._sharedService.arrayKeySearchValuesChangeForUser
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    onSaveRegistration() {
        const bodyUpdate: any = {}
        let resourceData: any = {}
        const arrSaveClientTop: any[] = this.clientTopServices.getAllArrClientTop()
        const index = this.clientTopServices.getIndex()
        let jsonNow: any
        let id: any = ''
        const clientInfor = {}
        const resultClientInfor = this.idClient
        clientInfor[resultClientInfor] = true
        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const status: any = {
            client: {
                map: clientInfor,
            },
            clientVisit: {
                paths: clientVisit,
            },
            clinic: {
                paths: {
                    '{}': true,
                },
            },
            setting: {
                map: {
                    common: true,
                },
                paths: {
                    '{}': true,
                },
            },
            staff: {
                paths: {
                    '{"roles":"cordinator"}': true,
                    '{"roles":"doctor"}': true,
                    '{}': true,
                },
            },
        }
        if (arrSaveClientTop[index]) {
            jsonNow = arrSaveClientTop[index]
            if (jsonNow['_id']) {
                id = jsonNow['_id']
            }
            if (id == '') {
                bodyUpdate['clientId'] = this.idClient
            }
            bodyUpdate['face-1'] = jsonNow['face-1']
            bodyUpdate['face-2'] = jsonNow['face-2']
            bodyUpdate['face-3'] = jsonNow['face-3']
            bodyUpdate['face-4'] = jsonNow['face-4']
            bodyUpdate['face-5'] = jsonNow['face-5']
            bodyUpdate['face-6'] = jsonNow['face-6']
            bodyUpdate['face-all'] = jsonNow['face-all']

            bodyUpdate['tooth-all'] = jsonNow['tooth-all']
            bodyUpdate['tooth-right'] = jsonNow['tooth-right']
            bodyUpdate['tooth-front'] = jsonNow['tooth-front']
            bodyUpdate['tooth-left'] = jsonNow['tooth-left']
            bodyUpdate['tooth-lower'] = jsonNow['tooth-lower']
            bodyUpdate['tooth-overjet'] = jsonNow['tooth-overjet']
            bodyUpdate['tooth-upper'] = jsonNow['tooth-upper']

            bodyUpdate['aligner-all'] = jsonNow['aligner-all']
            bodyUpdate['aligner-right'] = jsonNow['aligner-right']
            bodyUpdate['aligner-front'] = jsonNow['aligner-front']
            bodyUpdate['aligner-left'] = jsonNow['aligner-left']
            bodyUpdate['aligner-lower'] = jsonNow['aligner-lower']
            bodyUpdate['aligner-overjet'] = jsonNow['aligner-overjet']
            bodyUpdate['aligner-upper'] = jsonNow['aligner-upper']

            bodyUpdate['xp-1'] = jsonNow['xp-1']
            bodyUpdate['xp-2'] = jsonNow['xp-2']
            bodyUpdate['xp-3'] = jsonNow['xp-3']
            bodyUpdate['xp-4'] = jsonNow['xp-4']
            bodyUpdate['xp-5'] = jsonNow['xp-5']
            bodyUpdate['xp-6'] = jsonNow['xp-6']
            bodyUpdate['xp-all'] = jsonNow['xp-all']

            bodyUpdate['other-1'] = jsonNow['other-1']
            bodyUpdate['other-2'] = jsonNow['other-2']
            bodyUpdate['other-3'] = jsonNow['other-3']
            bodyUpdate['other-4'] = jsonNow['other-4']
            bodyUpdate['other-5'] = jsonNow['other-5']
            bodyUpdate['other-6'] = jsonNow['other-6']
            bodyUpdate['other-all'] = jsonNow['other-all']

            bodyUpdate['movie-1'] = jsonNow['movie-1']
            bodyUpdate['movie-2'] = jsonNow['movie-2']
            bodyUpdate['movie-3'] = jsonNow['movie-3']
            bodyUpdate['movie-4'] = jsonNow['movie-4']
            bodyUpdate['movie-5'] = jsonNow['movie-5']
            bodyUpdate['movie-6'] = jsonNow['movie-6']
            bodyUpdate['movie-all'] = jsonNow['movie-all']

            if (id != '') {
                resourceData = {
                    actions: [
                        {
                            type: 'update',
                            collection: 'clientVisit',
                            id: id,
                            value: bodyUpdate,
                        },
                    ],
                    status: status,
                }
            } else {
                resourceData = {
                    actions: [
                        {
                            type: 'create',
                            collection: 'clientVisit',
                            value: bodyUpdate,
                        },
                    ],
                    status: status,
                }
            }
            this.auth.authToken().then(tokenReNew => {
                this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                    let arrRegistration = success['response']['clientVisit']['paths']['' + result]
                    let clientInfo = success['response']['client']['map'][resultClientInfor]
                    let faceImage = clientInfo['faceImage']
                    if (typeof arrRegistration !== 'undefined' && arrRegistration.length > 0) {
                        arrRegistration.sort((function(obj1, obj2) {
                            return obj1.dateStringToInit - obj2.dateStringToInit
                        }))
                        const imageFrontSmile = this.getFrontSmileToAvatar(arrRegistration)
                        if (imageFrontSmile !== undefined) {
                            if (typeof faceImage === 'undefined') {
                                this.callApiUpdateFaceImage(imageFrontSmile)
                            } else if (faceImage !== '') {
                                if (faceImage['id'] !== imageFrontSmile['id']) {
                                    this.callApiUpdateFaceImage(imageFrontSmile)
                                } else if (imageFrontSmile['matrix'] != undefined && faceImage['matrix'] !== imageFrontSmile['matrix'].toString()) {
                                    this.callApiUpdateFaceImage(imageFrontSmile)
                                }
                            }
                        }
                    }
                    this.resetStateServices()

                    arrRegistration = success['response']['clientVisit']['paths']['' + result]
                    let countArrDataRegistration = success['response']['clientVisit']['paths']['' + result].length

                    if (countArrDataRegistration > 0) {
                        arrRegistration.sort((function(obj1, obj2) {
                            return obj1.dateStringToInit - obj2.dateStringToInit
                        }))
                        const imageFrontSmile = this.getFrontSmileToAvatar(arrRegistration)
                        if (imageFrontSmile !== undefined) {
                            if (typeof this.faceImage === 'undefined') {
                                this.callApiUpdateFaceImage(imageFrontSmile)
                            } else if (this.faceImage !== '') {
                                if (this.faceImage['id'] !== imageFrontSmile['id']) {
                                    this.callApiUpdateFaceImage(imageFrontSmile)
                                } else if (imageFrontSmile['matrix'] != undefined && this.faceImage['matrix'] !== imageFrontSmile['matrix'].toString()) {
                                    this.callApiUpdateFaceImage(imageFrontSmile)
                                }
                            }
                        }
                    }


                })
            })
        }
    }

    getImageFacImage() {
        this.clientTopServices.changeEmitGetFaceImage$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ClientDetailComponent-clientFaceImage') {
                        if (success[1]) {
                            this.faceImage = success[1]
                        }
                    } else
                        if (success[0] === 'ClientDetailComponent-clientFaceImage-update') {
                            if (success[1]) {
                                this.faceImage = success[1]
                            }
                        }

                }
            },
        )
    };

    saveSimulation(arrSimulation: any[] = [], routesLink) {
        const bodyCreate: any = {}
        bodyCreate['simulations'] = arrSimulation

        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const map: any = {}
        map[this.idClient] = true
        const status: any = {
            client: {
                map: map,
            },
            clientVisit: {
                paths: clientVisit,
                map: map,
            },
            clinic: {
                paths: {
                    '{}': true,
                },
            },
            setting: {
                map: {
                    common: true,
                },
                paths: {
                    '{}': true,
                },
            },
            staff: {
                paths: {
                    '{"roles":"cordinator"}': true,
                    '{"roles":"doctor"}': true,
                    '{}': true,
                },
            },
        }
        const resourceData: any = {
            actions: [
                {
                    type: 'update',
                    collection: 'client',
                    id: this.idClient,
                    value: bodyCreate,
                },
            ],
            status: status,
        }

        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.resetStateServices()
                this.router.navigate([this.redirectUrl + routesLink])
            })
        })
    }

    checkChangeSimulation(arrSimulation: any[] = [], routesLink, activeIndex) {
        const arrSimulationSave: any[] = arrSimulation
        this.changeLanguage()
        onsNotification.confirm({
            message: this.en['alert-content'],
            title: this.en['alert-title'],
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
            modifier: 'rowfooter',
            callback: i => {
                if (i === 0) {
                } else if (i === 1) {
                    this.statusNewClient = false
                    this.resetStateServices()
                    this.activeIndex = activeIndex
                    this.router.navigate([this.redirectUrl + routesLink])
                } else if (i === 2) {
                    this.statusNewClient = false
                    this.activeIndex = activeIndex
                    this.saveSimulation(arrSimulationSave, routesLink)
                }
            },
        })
    }

    checkMovedUpPage(routesLink, activeIndex) {
        if (this.clientTopServices.checkChangeData === true) {
            this.changeLanguage()
            onsNotification.confirm({
                message: this.en['alert-content'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 0) {
                    } else if (i === 1) {
                        this.statusNewClient = false
                        this.resetStateServices()
                        this.activeIndex = activeIndex
                        if (routesLink == '/app/main/client/search') {
                            this.router.navigate([routesLink])
                        } else {
                            this.router.navigate([this.redirectUrl + routesLink])
                        }
                    } else if (i === 2) {
                        this.statusNewClient = false
                        // onSaveRegistration
                        // const page = 'slideshow';
                        this.onSaveRegistration()
                        this.activeIndex = activeIndex
                        if (routesLink == '/app/main/client/search') {
                            this.router.navigate([routesLink])
                        } else {
                            this.router.navigate([this.redirectUrl + routesLink])
                        }
                    }
                },
            })
        } else {
            const simulation1: any = this.clientTopServices.returnArrSimulation()
            if (simulation1 != null && simulation1['simulation'] != undefined) {
                this.checkChangeSimulation(simulation1['simulation'], routesLink, activeIndex)
            } else {
                this.resetStateServices()
                if (this.statusNewClient == false) {
                    this.activeIndex = activeIndex
                }
                if (routesLink == '/app/main/client/search') {
                    this.router.navigate([routesLink])
                } else {
                    // console.log(routesLink);
                    // console.log(this.redirectUrl);
                    this.router.navigate([this.redirectUrl + routesLink])
                }
                this.statusNewClient = false
            }
        }
    }

    resetStateServices() {
        this.stateServices.emitChangeHash(null)
        this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
        this.clientTopServices.changecheckDataAfterConfirm(null)
        this.clientTopServices.showClientArrayTop(null)
        this.clientTopServices.emitChangeArrCopy(null)
        this.clientTopServices.emitChangeListTopImageData(null)
        this.clientTopServices.emitChangeChangeStatus(null)
        this.clientTopServices.emitChangeParent(null)
        this.clientTopServices.emitChangeIndexToGetNote(null)
        this.clientTopServices.emitChangeRefresh(null)
        this.clientTopServices.emitChange(null)
        this.clientTopServices.emitChangeSlider(null)
        this.clientTopServices.emitChangeValueSlider(null)
        this.clientTopServices.emitChangeHash(null)
        this.clientTopServices.emitChangeStyle(null)
        this.clientTopServices.emitChangeRefreshArr(null)
        this.clientTopServices.emitChangeSlideshow(null)
        this.clientTopServices.emitGetFaceImage(null)
        this.clientTopServices.emitChangeInfoUrlChange(null)
        this.clientTopServices.emitChangeNoteList(null)
        this.clientTopServices.emitChangeViewDetailUser(null)
        this.clientTopServices.emitChangeActiveIndex(null)
        this.clientTopServices.emitChangePreventationName(null)
        this.clientTopServices.resetChangeInit()
        this.clientTopServices.changecheckDataAfterConfirm(false)
        this.clientTopServices.resetAllArrClientTop()
        this.clientTopServices.emitChangeIsCreated(null)
        this.clientTopServices.resetTabName()
        this.clientTopServices.resetIndex()
        this.clientTopServices.emitChangeArrSimulation(null)
    }

    checkRedirect(routesLink, activeIndex) {
        // console.log((isUndefined(this.tmpActiveIndex) && !isUndefined(activeIndex)) || this.tmpActiveIndex === activeIndex);
        let routeLinkChange = routesLink
        if ((isUndefined(this.tmpActiveIndex) && !isUndefined(activeIndex)) || this.tmpActiveIndex === activeIndex) {
            routeLinkChange = '/reload/' + routesLink
            // console.log(this.redirectUrl);
            // this.router.navigate([this.redirectUrl + '/reload/' + routesLink]);
        }
        this.tmpActiveIndex = activeIndex
        // routerLink="{{ showarrayMenu.routerLink }}"
        this.checkMovedUpPage(routeLinkChange, activeIndex)
        const arr = ['checkRotesLink', routesLink]
        this._sharedService.emitChange(arr)
    }

    checkSave(routesLink) {
        const arr = ['checkRotesLink', routesLink]
        this._sharedService.emitChange(arr)
    }

    onAction($event) {
        setTimeout(() => {
            $event.done()
            // this.items.push(0);
        }, 200)
    }

    changeOfRoutes() {
    }

    canDeactivate() {
        // return this.itunes.results.length > 0;
    }

    onChangeState($event) {
        // switch ($event.state) {
        //     case 'initial':
        //         this.message = 'Pull down to refresh';
        //         break;
        //     case 'preaction':
        //         this.message = 'Release to refresh';
        //         break;
        //     case 'action':
        //         this.message = 'Loading data...';
        //         break;
        // }
    }

    callApiInfoClient(idClient) {
        const clientId = {}
        const result = idClient
        clientId[result] = true
        const resourceDataAccessLog = {
            actions: [],
            status: {
                client: {
                    map: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }


        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    let clientInfoRespon: any
                    if (success['response']['client'] != undefined) {
                        clientInfoRespon = this.clientInfo = success['response']['client']['map'][result]
                        this.presentationName = success['response']['client']['map'][result]['presentationName']
                    }

                    const local: any = localStorage.getItem('presentationModeValue')

                    if (clientInfoRespon !== undefined) {
                        if (clientInfoRespon['faceImage'] != undefined && clientInfoRespon['faceImage']['id'] !== '') {
                            this.urlImage = clientInfoRespon['faceImage']
                            this.urlImageAge = clientInfoRespon['faceImage']
                        } else {
                            this.urlImage = {}
                            this.urlImage['id'] = ''
                        }
                    } else {
                        this.urlImage = {}
                        this.urlImage['id'] = ''

                        this.router.navigate(['./app/main/client/not-found'])
                        return
                    }
                    if (local === 'true') {
                        this.urlImage = {}
                        this.urlImage['id'] = ''
                    } else if (local === 'false') {
                        if(this.urlImageAge) {
                            this.urlImage = this.urlImageAge
                        }else {
                            this.urlImage = {}
                            this.urlImage['id'] = ''
                        }
                    }
                    this.operator = ''
                    if (clientInfoRespon.familyName) {
                        this.operator = clientInfoRespon.familyName + ' '
                    }
                    if (clientInfoRespon.firstName) {
                        this.operator += clientInfoRespon.firstName
                    }
                },
            )
        })
    }

    getFrontSmileToAvatar(arrImageClientTop) {
        const arrImageClientTopFrontSmile = arrImageClientTop
        for (let i = arrImageClientTopFrontSmile.length - 1; i >= 0; i--) {
            if (arrImageClientTopFrontSmile[i]['face-1'] != undefined && arrImageClientTopFrontSmile[i]['face-1'].length > 0 && arrImageClientTopFrontSmile[i]['face-1'][0]['id'] !== '') {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            } else if (i == 0) {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            }
        }
    }

    callApiUpdateFaceImage(imageFace) {
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: {
                        faceImage: imageFace,
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
            },
        })
        console.log('layout app callApiUpdateFaceImage')
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.urlImage = success['response']['client']['map'][result]['faceImage']
            })
        })
    }

    callApiEmptyFaceImage() {
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: {
                        faceImage: {id: ''},
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
            },
        })
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.urlImage = {}
                this.urlImage['id'] = ''
            })
        })
    }

    checkRedirectHome(routesLink, activeIndex) {
        if (this.isExpiryTime()) {
            this.logout()
        } else {
            // console.log((isUndefined(this.tmpActiveIndex) && !isUndefined(activeIndex)) || this.tmpActiveIndex === activeIndex);
            let routeLinkChange = routesLink
            if ((isUndefined(this.tmpActiveIndex) && !isUndefined(activeIndex)) || this.tmpActiveIndex === activeIndex) {
                routeLinkChange = '/reload/' + routesLink
                // console.log(this.redirectUrl);
                // this.router.navigate([this.redirectUrl + '/reload/' + routesLink]);
            }
            this.tmpActiveIndex = activeIndex
            // routerLink="{{ showarrayMenu.routerLink }}"
            this.checkMovedUpPage(routeLinkChange, activeIndex)
            const arr = ['checkRotesLink', routesLink]
            this._sharedService.emitChange(arr)
        }
    }

    isExpiryTime() {
        if (this.auth.getItem('user')) {
            const user = JSON.parse(this.auth.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.auth.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if(timeOut > timeNow){
                return false;
            }
        }
        return true;
    }


    logout() {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('timeout')
        this.cookieService.delete('token')
        jQuery('body').attr('class', 'blue')
        localStorage.removeItem('urlLogo')
        localStorage.removeItem('classThemeBody')
        return this.router.navigateByUrl('/app/login')
    }

    checkReceipt(id: number){
        if(id == 9){
            if(localStorage.getItem('lang') == 'true') {
                return false
            }
            if(localStorage.getItem('lang') == 'false') return true
        }
        else return true;

    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/layout-app-client-detail/layout-app-client-detail.component.ts